import { combineReducers } from "@reduxjs/toolkit";
import authSlice, { logout, setUser } from "../slices/authSlice";
import internalToolSlice from "../slices/internalToolSlice";
import workspaceSlice from "../slices/workspaceSlice";
import competitorsSlice from "../slices/competitorsSlice";

const appReducer = combineReducers({
  auth: authSlice,
  internalTool: internalToolSlice,
  workspace: workspaceSlice,
  competitors: competitorsSlice,
});

export const rootReducer = (state, action) => {
  const identityChanged =
    action.type === setUser.type &&
    (!state?.auth?.isInitialized ||
      state.auth.user?.uid !== action.payload?.uid);
  if (action.type === logout.fulfilled.type || identityChanged) {
    // Identity changes discard the previous session's application data.
    return appReducer(
      identityChanged ? { auth: state?.auth } : undefined,
      action,
    );
  }
  return appReducer(state, action);
};
